import {
  Button,
  Modal,
  Form,
  Input,
  Upload,
  message,
  InputNumber,
  Radio,
} from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { MyValidateMessages } from '../../../../utils/validateMessaage'
import { newBanner, postGroup } from '../../../../api/api'
import UploadOnePicture from '../../../../components/upLoadOnePicture/uploadPicture'

export default function NewGroup(props) {
  //表单设置
  const { TextArea } = Input
  const [componentDisabled, setComponentDisabled] = useState(false)
  const onFormLayoutChange = ({ disabled }) => {
    setComponentDisabled(disabled)
  }
  const [form] = Form.useForm()
  const [total, setTotal] = useState(props.total)

  //modal设置
  const [open, setOpen] = useState(false)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [groupImage, setGroupImage] = useState()
  const [codeImage, setCodeImage] = useState()

  const showModal = () => {
    setOpen(true)
  }

  const setIsfresh = props.setIsFresh //刷新组件

  const handleOk = (e) => {
    form.setFieldValue('group_image', groupImage)
    form.setFieldValue('code_image', codeImage)
    form.validateFields().then((res) => {
      // const params = Object.assign(res, { position: total + 1 })
      postGroup(res).then((res) => {
        console.log(res)
        setIsfresh((pre) => {
          return !pre
        })
        setTotal(total + 1)
        message.success('新建轮播图成功！')
        form.resetFields()
        setOpen(false)
      })
    })
  }

  const handleCancel = () => {
    console.log('Clicked cancel button')
    setOpen(false)
  }

  //向父组件传递图片网址
  const [url, setUrl] = useState()
  const setImgUrl = (url) => {
    setUrl(url)
    // console.log(url);
  }

  return (
    <>
      <Button icon={<PlusOutlined />} type="primary" onClick={showModal}>
        新建
      </Button>
      <Modal
        title="新建/编辑内容"
        okText="确定"
        cancelText="取消"
        open={open}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
        destroyOnClose
      >
        <Form
          validateMessages={MyValidateMessages}
          labelCol={{
            span: 6,
          }}
          wrapperCol={{
            span: 14,
          }}
          layout="horizontal"
          onValuesChange={onFormLayoutChange}
          disabled={componentDisabled}
          form={form}
        >
          <Form.Item
            label="群聊名称"
            name="name"
            rules={[
              {
                required: true,
                max: 50,
              },
            ]}
          >
            <Input placeholder="上限50字" />
          </Form.Item>

          <Form.Item
            label="状态"
            name="is_visible"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={1}>展示</Radio>
              <Radio value={0}>隐藏</Radio>
            </Radio.Group>
          </Form.Item>

          <Form.Item
            label="优先级"
            name="priority"
            rules={[
              {
                type: 'number',
                required: true,
                min: 0,
                max: 99,
              },
            ]}
          >
            <InputNumber
              style={{ width: '150px' }}
              placeholder="输入0-99的整数"
            />
          </Form.Item>
          <Form.Item
            label="群聊图片"
            valuePropName="group_image"
            name="group_image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setGroupImage} image={null} />
          </Form.Item>

          <Form.Item
            label="群二维码图片"
            valuePropName="code_image"
            name="code_image"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <UploadOnePicture deliverUrl={setCodeImage} image={null} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}
